import { render, staticRenderFns } from "./AddOthersAccount.vue?vue&type=template&id=b957ad22"
import script from "./AddOthersAccount.vue?vue&type=script&lang=js"
export * from "./AddOthersAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports